import { PortalV2FetchError } from "~/services/portalV2Api";
import type { PortalV2Location } from "~/services/portalV2Api";

/**
 * Gates the redirect to a lookup's stored settingId: sending a gone setting to p2 loops, since
 * p2 404s back to p3. Transient failures keep the benefit of the doubt and still redirect.
 */
export function isSettingServableInP2({
	settingId,
	p2Location,
	p2Error,
}: {
	settingId: number;
	p2Location: PortalV2Location | null;
	p2Error: unknown;
}): boolean {
	if (p2Error instanceof PortalV2FetchError && p2Error.status === 404) {
		return false;
	}
	return p2Location === null || p2Location.registrationSettings.some((s) => s.id === settingId);
}
